import Frame from '../components/Frame';
import { useAtomValue } from 'jotai';
import { loadableAssets } from '../loader/cache';
import GameBoard from '../components/Game';
import { useProgress } from '@react-three/drei';

function Main() {
  console.log("Main")
  return (<Frame>
    <GameBoard />       
  </Frame>)
}

function Loading() {
  const p = useProgress()
  console.log('Loading... ', p)
  return <div>Loading...</div>
  // return <Progress value={p.progress} />
}


function WrappedMain() {
  console.log('WRAPPED MAIN')
  const value = useAtomValue(loadableAssets)
  if(value.state !== 'hasData') {
    return <Loading />
  }
  return <Main />
}

export default WrappedMain